import React from 'react';
import { motion } from 'framer-motion';
import { CyberButton } from './ui/CyberButton';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-71">
      {/* Animated Background Grid */}
      <div className="absolute inset-0 bg-cyber-black" data-id="element-72">
        <div className="absolute inset-0 bg-cyber-grid bg-[length:50px_50px] opacity-20 animate-[pulse_4s_ease-in-out_infinite]" data-id="element-73" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyber-black/50 to-cyber-black" data-id="element-74" />
      </div>

      {/* Floating Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-75">
        <motion.div animate={{
        y: [0, -20, 0],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 5,
        repeat: Infinity
      }} className="absolute top-1/4 left-1/4 w-64 h-64 bg-cyber-purple/20 rounded-full blur-[100px]" data-id="element-76" />
        <motion.div animate={{
        y: [0, 20, 0],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 7,
        repeat: Infinity
      }} className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyber-cyan/20 rounded-full blur-[100px]" data-id="element-77" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-79">
          <h2 className="text-cyber-cyan font-rajdhani font-bold text-xl md:text-2xl tracking-[0.5em] uppercase mb-4" data-id="element-80">
            Welcome to the Future
          </h2>

          <h1 className="text-5xl md:text-7xl lg:text-9xl font-orbitron font-black text-white mb-6 leading-tight" data-id="element-81">
            <span className="block glitch-text" data-text="ALPHA" data-id="element-82">
              ALPHA
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyber-purple via-cyber-cyan to-cyber-green" data-id="element-83">
              GAMER
            </span>
          </h1>

          <p className="max-w-2xl mx-auto text-gray-400 font-rajdhani text-lg md:text-2xl mb-10 border-l-2 border-cyber-purple pl-6 text-left md:text-center md:border-l-0 md:pl-0" data-id="element-84">
            London's premier cyberpunk gaming sanctuary. High-performance rigs,
            immersive VR, and a community forged in neon.
          </p>

          <div className="flex flex-col md:flex-row gap-6 justify-center items-center" data-id="element-85">
            <CyberButton variant="primary" onClick={() => document.getElementById('services')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-86">
              Enter The Grid
            </CyberButton>
            <CyberButton variant="outline" onClick={() => document.getElementById('location')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-87">
              Locate Base
            </CyberButton>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-cyber-cyan" data-id="element-88">
        <div className="w-6 h-10 border-2 border-cyber-cyan rounded-full flex justify-center p-1" data-id="element-89">
          <div className="w-1 h-2 bg-cyber-green rounded-full" data-id="element-90" />
        </div>
      </motion.div>
    </section>;
}